import React from "react";
import { Link } from "react-router-dom";

const AdminPanel = () => {
  return (
    <div
      className="min-h-screen w-screen"
      style={{
        background: "linear-gradient(to bottom, #24004266 40%, #4FCBE6 100%)",
      }}
    >
      <div className="max-w-4xl w-full mx-auto mt-20 shadow-lg rounded-lg p-6 space-y-6 bg-white">
        <h2 className="text-3xl font-semibold text-gray-800 text-center">
          Admin Dashboard
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-8 max-w-5xl mx-auto">
          <Link
            to="/admin/schedule"
            className="px-6 py-3 bg-blue-600 text-white rounded-xl shadow hover:bg-blue-700 transition text-center"
          >
            Schedule Session
          </Link>
          <Link to="/admin/register" className="px-6 py-3 bg-indigo-600 text-white rounded-xl shadow hover:bg-indigo-700 transition text-center">Register User</Link>
          <Link
            to="/admin/resendpassword"
            className="px-6 py-3 bg-purple-600 text-white rounded-xl shadow hover:bg-purple-700 transition text-center"
          >
            Resend Temp Password
          </Link>
          <Link
            to="/admin/presignlinkgenerator"
            className="px-6 py-3 bg-orange-600 text-white rounded-xl shadow hover:bg-orange-700 transition text-center"
          >
            Presign Link Generator
          </Link>
        </div>
      </div>
    </div>
  );
};
export default AdminPanel;
